import "../css/component/Header.scss";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import useScroll from "../custom_hooks/useScroll.tsx";
import ImgLogo01 from "../assets/img/common/logo_01.png";
import ImgLogo02 from "../assets/img/common/logo_02.png";
import MailIcon from "../assets/img/header/mail.png";
import MailIconFloat from "../assets/img/header/mail_float.png";
import INFO from "../setting/INFO";

interface HeaderProps {
  isEmail: boolean;
  data: Array<{
    name: string;
    href: string;
    children: Array<{
      name: string;
      href: string;
    }>;
  }>;
}

const HeaderWrapper = styled.header`
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  justify-content: center;
  width: 100%;
  height: 60px;
  background: ${INFO.THEME_COLOR};
  z-index: 999;
  padding-top: 11px;
  padding-bottom: 11px;
  transition: all 0.3s linear;
  &::before,
  &::after {
    content: "";
    min-width: 100px;
  }
`;
const Term = styled.span`
    width 40vw;
`;

const MainMenuUl = styled.ul`
  display: inline-flex;
  justify-content: right;
  list-style: none;
  min-width: fit-content;
  height: 100%;
  margin: 0px;
`;
const MainMenuLi = styled.li`
  text-transform: uppercase;
  font-size: 16px;
  color: ${(props) => (props.selected ? "black" : "white")};
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
`;
const MainMenuLink = styled.a`
  width: 100%;
  height: 100%;
  padding: 0px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.selected ? "#ffc107" : "#fff")};
`;
const SubMenuUl = styled.ul`
  position: absolute;
  width: 120%;
  top: 0px;
  left: 0px;
  visibility: hidden;
  padding: 60px 0 0 0;
  left: 50%;
  transform: translateX(-50%) scaleY(0.4);
  transform-origin: top;
  justify-content: right;
  list-style: none;
  min-width: fit-content;
  background-color: #003b5dd9;
`;
const SubMenuLi = styled.li`
  padding: 0px;
  font-size: 14px;
  height: 40px;
  align-items: center;
  display: flex;
  justify-content: center;
  border-bottom: 1px #00163b solid;
  margin: 0 7px;

  // background-repeat: round;
  // padding: 0 7px;

  &:last-of-type {
    border-bottom: none;
  }
`;
const SubMenuLink = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a4c2e6;
`;

const Logo = styled.img`
  display: inline;
  /* width: 130px; */
  height: 40px;
  margin-left: 0px;
  padding: 17px 0;
  cursor: pointer;
  transition: all 0.3s linear;
`;

const EmailWrapper = styled.a`
  display: inline;
  cursor: pointer;
  font-size: 14px;
  font-family: SCDream5;
  color: #fff;
  text-decoration: none;
  margin-left: 30px;
  min-width: fit-content;
`;
const EmailImg = styled.img`
  width: 20px;
  vertical-align: middle;
  padding-bottom: 3px;
  background-size: cover;
`;

export default function Header(props: HeaderProps) {
  const menuData = props.data;
  const isEmail = props.isEmail || true;
  const { pathname } = useLocation();
  const { y } = useScroll();
  const isFloating: boolean = y > 0 || pathname != "/";
  const navigate = useNavigate();
  const clickLink = (link) => {
    navigate(link);
    window.scrollTo({ top: 0, left: 0 });
    document.querySelector(".heaher-main-li.hover")?.classList.remove("hover");
  };

  return (
    <HeaderWrapper id="header-pc" className={isFloating ? "float" : ""}>
      <Logo
        src={isFloating ? ImgLogo01 : ImgLogo02}
        onClick={() => {
          navigate("/");
          window.scrollTo({ top: 0, left: 0 });
        }}
      />
      <Term />
      <MainMenuUl>
        {menuData.map((menu, idx) => {
          const isSelected = pathname.startsWith(menu.href);

          return menu.children ? (
            <MainMenuLi
              key={`main-menu${idx}`}
              className="heaher-main-li"
              onMouseOver={(e) => {
                e.currentTarget.classList.add("hover");
              }}
              onMouseOut={(e) => {
                e.currentTarget.classList.remove("hover");
              }}
            >
              <MainMenuLink
                selected={isSelected}
                onClick={() => {
                  clickLink(menu.children[0].href);
                }}
              >
                {menu.name}
              </MainMenuLink>
              <SubMenuUl>
                {menu.children?.map((child, childIdx) => (
                  <SubMenuLi key={`sub-menu${childIdx}`} isLast={menu.children.length - 1 === childIdx}>
                    <SubMenuLink
                      selected={pathname.startsWith(child.href)}
                      onClick={() => {
                        clickLink(child.href);
                      }}
                    >
                      {child.name}
                    </SubMenuLink>
                  </SubMenuLi>
                ))}
              </SubMenuUl>
            </MainMenuLi>
          ) : (
            <MainMenuLi key={`main-menu${idx}`}>
              <MainMenuLink
                selected={isSelected}
                onClick={() => {
                  clickLink(menu.href);
                }}
              >
                {menu.name}
              </MainMenuLink>
            </MainMenuLi>
          );
        })}
      </MainMenuUl>

      {isEmail ? (
        <EmailWrapper href="mailto:jinsun.yang@pluspro.kr">
          <EmailImg src={isFloating ? MailIconFloat : MailIcon} /> 제안하기
        </EmailWrapper>
      ) : null}
    </HeaderWrapper>
  );
}
